import Avatar from '@mui/material/Avatar';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ArrowUpRight from '~/assets/images/arrow-up-right.svg';

interface AppLinkProps {
  url: string;
  urlText: string;
  testId: string;
}

const AppLink: React.FC<AppLinkProps> = ({ url, urlText, testId }) => (
  <Link
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    sx={{ textDecoration: 'none' }}
    data-testid={testId}
  >
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="body2">{urlText}</Typography>
      <Avatar src={ArrowUpRight} sx={{ width: 16, height: 16 }} />
    </Stack>
  </Link>
);

export default AppLink;
